import { useQuery } from '@tanstack/react-query';
import { getOrders } from '../services/api';
import { DEMO, useDemo } from '../components/DemoModal';
import { MATERIAL_NAME, MATERIAL_UNIT, ORDER_STATUS_LABEL, type OrderStatus } from '../types';
import { money } from '../utils/format';

const STATUSES: OrderStatus[] = ['open', 'in_progress', 'filled'];

export default function Orders() {
  const { showDemo } = useDemo();
  const { data, isLoading } = useQuery({ queryKey: ['orders'], queryFn: () => getOrders(300) });
  const orders = data?.orders ?? [];

  return (
    <div className="page-wrap">
      <h2>Orders</h2>
      {isLoading ? (
        <p className="muted">Loading…</p>
      ) : (
        <table className="data-table card" style={{ display: 'table' }}>
          <thead>
            <tr>
              <th>Order #</th>
              <th>Date</th>
              <th>Customer</th>
              <th>Material</th>
              <th>Deliver to</th>
              <th style={{ textAlign: 'right' }}>Qty</th>
              <th style={{ textAlign: 'right' }}>$/unit</th>
              <th style={{ textAlign: 'right' }}>Total</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((o) => (
              <tr key={o.id}>
                <td>{o.order_no ?? o.id.slice(0, 8)}</td>
                <td>{o.created_at.slice(0, 10)}</td>
                <td>{o.customer_name ?? '—'}</td>
                <td>
                  {MATERIAL_NAME[o.material] ?? o.material}{' '}
                  <span className="muted">({MATERIAL_UNIT[o.material] ?? ''})</span>
                </td>
                <td>{o.site_address}</td>
                <td style={{ textAlign: 'right' }}>{o.quantity}</td>
                <td style={{ textAlign: 'right' }}>{money(o.delivered_price_per_unit)}</td>
                <td style={{ textAlign: 'right', fontWeight: 700 }}>{money(o.delivered_total)}</td>
                <td>
                  <select
                    className="select"
                    style={{ width: 'auto' }}
                    value={o.status}
                    onChange={() => showDemo(DEMO.updateOrderStatus)}
                  >
                    {STATUSES.map((s) => (
                      <option key={s} value={s}>
                        {ORDER_STATUS_LABEL[s]}
                      </option>
                    ))}
                  </select>
                </td>
              </tr>
            ))}
            {orders.length === 0 && (
              <tr>
                <td colSpan={9} className="muted">
                  No orders yet.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
}
